import React, { useState, useEffect, useRef } from "react";
import "../../styles/login.scss";
import { useDispatch } from "react-redux";
import { loginReducer } from "../../Redux/store";
import { Route, Navigate, useNavigate } from 'react-router-dom';
import axios from "axios";
import Box from "@mui/material/Box";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import TextField from "@mui/material/TextField";
import { InputAdornment, IconButton } from "@mui/material";
import LoginLogo from "../../images/Cyber security.svg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
function ResetPassword() {


  const dispatch = useDispatch();
  
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNoMatchError,setNoMatchError]= useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showRetypePassword, setShowRetypePassword] = useState(false);
  const [validPassword,setValidPassword]= useState(true);
  const [showEmptyOldPasswordError, setShowEmptyOldPasswordError] = useState(false);

  const validatePassword = (password) => {
    const passwordRegex = /^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.{8,})/;
    if (!passwordRegex.test(password)) {
      
        setValidPassword(false);
      
    }
    else{
      setValidPassword(true);
    }
};


  const [formData, setFormData] = useState({
    old_password: '',
    new_password: '',
    retry_password:'',

  });
  const [errors, setErrors] = useState({
    old_password: "",
    new_password: "",
    retry_password: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("formDatasfsdf",formData);
    let isValid = true;
    const newErrors = { ...errors };

    if (!formData.old_password.trim()) {
      newErrors.old_password = "Please enter the old password";
      isValid = false;
    } else {
      newErrors.old_password = "";
    }

    if (!formData.new_password.trim()) {
      newErrors.new_password = "Please enter the new password";
      isValid = false;
    } else {
      newErrors.new_password = "";
    }

    if (!formData.retry_password.trim()) {
      newErrors.retry_password = "Please re-enter the new password";
      isValid = false;
    } else if (formData.new_password !== formData.retry_password) {
      newErrors.retry_password = "Passwords do not match";
      isValid = false;
    } else {
      newErrors.retry_password = "";
    }

    setErrors(newErrors);

    if (!isValid) {
      return;
    }
    if(formData.new_password ===formData.retry_password)
    {
      let data={
        "oldpassword": formData.old_password,
        "password":  formData.new_password,
      }
      setNoMatchError(false)
      try {
      const resp = await axios.put("/v1/auth/resetpassword/"+JSON.parse(sessionStorage.getItem("userdata")).te_userid, data, {
        headers: {
            'Authorization': 'Bearer' + ' ' + sessionStorage.getItem("access_token"),
          }
      });
      if (resp.status === 200) {
        sessionStorage.clear();
        navigate("/login");

      }
    } catch (err) {
      if(err.response.data.message==="Incorrect old password"){
        toast.error("Old password is invalid", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      else if(err.response){
        toast.error(err.response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }
  }
    else{
      setNoMatchError(true)
    }
  };
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });

    if (e.target.name === "new_password") {
      validatePassword(e.target.value);
  }
  };
  
  const handleClickShowPassword = () => {
    setShowOldPassword(!showOldPassword);
    
  };
  const handleClickShowNewPassword = () => {
    setShowNewPassword(!showNewPassword);
    
  };

  const handleClickShowRetypePassword = () => {
    setShowRetypePassword(!showRetypePassword);
    
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const navigate = useNavigate();

  const handleCancel = () => {
    setFormData({
      old_password: '',
      new_password: '',
      retry_password:'',
    });

 
  };

  return (
    <>
    <div className="login-container">
  
        <div
          className="container-fluid login-background"
          style={{
            overflow: "auto"
          }}
        >
          <div className="row">
            <img
              className="Login-title"
              src={require("../../images/LoginTitle.png")}
              alt=""
            ></img>
          </div>
          <div className="row">
            <div className=" col-lg-5 text-center col-sm-12 col-one">
              <div>
              <form onSubmit={handleSubmit}>
              <div className="welcomeback">Reset Password</div>

                <Box
                 
                  sx={{
                    "& > :not(style)": { width: "459px" },
                  }}
                  noValidate
                  autoComplete="off"
                >
                  <div className="label-items">Old Password</div>
                  <TextField
                    id="old_password"
                    placeholder="Old Password"
                    variant="outlined"
                    InputLabelProps={{ shrink: false }}
                    maxLength={"15"}
                    name="old_password"
                    value={formData.old_password}
                    onChange={handleChange}
                    error={Boolean(errors.old_password)}
                    helperText={errors.old_password}
                    type={showOldPassword ? "text" : "password"}
                    sx={{
                        '& .MuiOutlinedInput-root':{
                          background:"#F9F8F4",
                          border:"1px solid #334456",
                          borderRadius:"10px"
                        },
                        "& .MuiOutlinedInput-root,.MuiOutlinedInput-root:hover":
                          {
                            "& > fieldset": {
                              borderColor: "#334456"
                            }
                          }
                      }}
                   
                     
                      InputProps={{
                     
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              style={{color:"#FFFFFF"}}
                            >
                              {showOldPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                        style : {
                          height : "47px",
                         
                        },
                      }}
                
                 
                  />

                  <div className="label-items">New Password</div>
                  <TextField
                    id="UserName"
                    placeholder="New Password"
                    variant="outlined"
                    InputLabelProps={{ shrink: false }}
                    maxLength={"15"}
                    name="new_password"
                    value={formData.new_password}
                    onChange={handleChange}
                    sx={{
                        '& .MuiOutlinedInput-root':{
                          background:"#F9F8F4",
                          border:"1px solid #334456",
                          borderRadius:"10px"
                        },
                        "& .MuiOutlinedInput-root,.MuiOutlinedInput-root:hover":
                          {
                            "& > fieldset": {
                              borderColor: "#334456"
                            }
                          }
                      }}
                      error={Boolean(errors.new_password)}
                    helperText={errors.new_password}
                    
                    type={showNewPassword ? "text" : "password"} 
               
                    InputProps={{
                   
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowNewPassword}
                            onMouseDown={handleMouseDownPassword}
                           
                          >
                            {showNewPassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                      style : {
                        height : "47px",
                      
                      },
                    }}
                   
                
                  />

         {formData.new_password !== '' && !validPassword && (
            <p className="warning-messages">Password must contain at least one capital letter, one symbol, and be at least 8 characters long.</p>
        )}
                  <div className="label-items">Retry Password</div>
                  <TextField
                    id="UserName"
                    placeholder="Retry Password"
                    variant="outlined"
                    InputLabelProps={{ shrink: false }}
                    maxLength={"15"}
                    name="retry_password"
                    value={formData.retry_password}
                    onChange={handleChange}
                    sx={{
                        '& .MuiOutlinedInput-root':{
                          background:"#F9F8F4",
                          border:"1px solid #334456",
                          borderRadius:"10px"
                        },
                        "& .MuiOutlinedInput-root,.MuiOutlinedInput-root:hover":
                          {
                            "& > fieldset": {
                              borderColor: "#334456"
                            }
                          }
                      }}
                    type={showRetypePassword ? "text" : "password"} 
                    error={Boolean(errors.retry_password)}
                    helperText={errors.retry_password}
                    
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowRetypePassword}
                            onMouseDown={handleMouseDownPassword}
                           
                          >
                            {showRetypePassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                      style : {
                        height : "47px",
                       
                      },
                    }}
                  // style={{ backgroundColor: "grey" }}
                  />
                </Box>
                {showNoMatchError==true &&(<p className="warning-messages">Password Missmatch</p>)}
                {/* <div >
                  <button className="generatepassword" type="submit">
                    Reset Password
                  </button>
                  <button onClick={handleCancel}>Cancel</button>
                </div> */}
                 <div className="submit-cancel">
              <button className="signupbtn" type="submit">
              Reset Password
              </button>
              <button
                className="signupbtn"
                onClick={handleCancel}
              >
                Cancel
              </button>
              </div>
                <br></br>
              </form>
              </div>
            </div>
            <div className="col-lg-1 col-md-12 col-sm-12"></div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-two">
              <img
                style={{ width: "auto", height: "auto" }}
                src={LoginLogo}
                alt="TATA Elxsi"
              ></img>
            </div>
          </div>
        </div>

     
      {/* </UnauthenticatedTemplate> */}
    </div>
  </>
  )
}

export default ResetPassword